import { jsx as _jsx } from "react/jsx-runtime";
import CodeMirror from "@uiw/react-codemirror";
import styles from "./index.module.css";
import { useAutoSaveDocument } from "../lib/useAutoSaveDocument";
export const MarkdownEditor = ({ documentId, content, onChange, config, onCreateEditor, onUpdate, readOnly = false, autoSaveEnabled = true, }) => {
    useAutoSaveDocument({ content, documentId, enabled: autoSaveEnabled });
    return (_jsx(CodeMirror, Object.assign({}, config, { className: styles.editorTextarea, value: content, onChange: onChange, onCreateEditor: onCreateEditor, onUpdate: onUpdate, readOnly: readOnly, editable: !readOnly })));
};
